// extracted by mini-css-extract-plugin
export var content = "_9c-3";
export var list = "_9c-4";
export var settingsContent = "_9c-7";
export var settingsPanel = "_9c-8";
export var state = "_9c-6";
export var triggerBadge = "_9c-2";
export var triggerButton = "_9c-1";
export var triggerShell = "_9c-0";
export var unreadDot = "_9c-5";